import {
  REQUEST_CASELIST_RESULTS,
  RECEIVE_CASELIST_RESULTS,
  ERROR_CASELIST_RESULTS,

  REQUEST_PROFILE_RESULTS,
  RECEIVE_PROFILE_RESULTS,
  ERROR_PROFILE_RESULTS,

  REQUEST_NOTIFICATIONS_RESULTS,
  RECEIVE_NOTIFICATIONS_RESULTS,
  ERROR_NOTIFICATIONS_RESULTS,

  REQUEST_STATISTICS_RESULTS,
  RECEIVE_STATISTICS_RESULTS,
  ERROR_STATISTICS_RESULTS,
  CASEFILTER_CHANGE,
  CASEFILTER_CLEARFILTER,

  REQUEST_GRID_FILTERS_RESULTS,
  RECEIVE_GRID_FILTERS_RESULTS,
  ERROR_GRID_FILTERS_RESULTS,

  REQUEST_GRID_FILTER_MENUS_RESULTS,
  RECEIVE_GRID_FILTER_MENUS_RESULTS,
  ERROR_GRID_FILTER_MENUS_RESULTS,

  REQUEST_CASE_HOLD_STATUS,
  RECEIVE_CASE_HOLD_STATUS,
  ERROR_RETRIEVE_CASE_HOLD_STATUS

} from 'typeConstants';
import { dashboard as initialState } from '../../initialState.tsx';
import { cloneDeep } from 'lodash';

const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CASELIST_RESULTS:
      return {
        ...state,
        fetchingCaseList: true
      };
    case REQUEST_PROFILE_RESULTS:
      return {
        ...state,
        fetchingProfile: true
      };
    case REQUEST_NOTIFICATIONS_RESULTS:
      return {
        ...state,
        fetchingNotifications: true
      };
    case REQUEST_STATISTICS_RESULTS:
      return {
        ...state,
        fetchingStatistics: true
      };
    case REQUEST_GRID_FILTERS_RESULTS:
      return {
        ...state,
        gotInitialGridFilters: true,
        fetchingGridFilters: true
      };
    case REQUEST_GRID_FILTER_MENUS_RESULTS:
      return {
        ...state,
        gotInitialGridFilterMenus: true,
        fetchingGridFilterMenus: true
      };
    case RECEIVE_CASELIST_RESULTS:
      return {
        ...state,
        caseList: action.payload,
        fetchingCaseList: false
      };
    case RECEIVE_PROFILE_RESULTS:
      return {
        ...state,
        profile: action.payload,
        fetchingProfile: false
      };
    case RECEIVE_NOTIFICATIONS_RESULTS:
      return {
        ...state,
        notifications: action.payload,
        fetchingNotifications: false
      };
    case RECEIVE_STATISTICS_RESULTS:
      return {
        ...state,
        statistics: action.payload,
        fetchingStatistics: false
      };
    case RECEIVE_GRID_FILTERS_RESULTS:
      return {
        ...state,
        gridFilters: action.payload,
        fetchingGridFilters: false
      };
    case RECEIVE_GRID_FILTER_MENUS_RESULTS:
      return {
        ...state,
        gridFilterMenus: action.payload,
        fetchingGridFilterMenus: false
      };
    case ERROR_CASELIST_RESULTS:
      return {
        ...state,
        fetchingCaseList: false
      };
    case ERROR_PROFILE_RESULTS:
      return {
        ...state,
        fetchingCasProfile: false
      };
    case ERROR_NOTIFICATIONS_RESULTS:
      return {
        ...state,
        fetchingNotifications: false
      };
    case ERROR_STATISTICS_RESULTS:
      return {
        ...state,
        fetchingStatistics: false
      };
    case ERROR_GRID_FILTERS_RESULTS:
      return {
        ...state,
        fetchingGridFilters: false
      };
    case ERROR_GRID_FILTER_MENUS_RESULTS:
      return {
        ...state,
        fetchingGridFilterMenus: false
      };
    case CASEFILTER_CHANGE:
      return {
        ...state,
        gridFilters: action.payload
      };
    case CASEFILTER_CLEARFILTER:
      {
        let filters = cloneDeep(state.gridFilters);
        let filter = filters.find(x => x.term === 'appraiser');

        if (filter !== null || filter !== undefined) {
          filter.id = "";
          filter.code = "all";
        }
        return {
          ...state,
          gridFilters: filters
        };


      }
    case REQUEST_CASE_HOLD_STATUS:
      return {
        ...state,
        fetchingHoldStatus: true,
      };
    case RECEIVE_CASE_HOLD_STATUS: 
      return {
        ...state,
        fetchingHoldStatus: false,
        holdStatus: action.payload,
      };
    case ERROR_RETRIEVE_CASE_HOLD_STATUS:
      return {
        ...state,
        fetchingHoldStatus: false,
      };

    default:
      return state;
  }
};

export default dashboard;
